import { useContext, useState } from "react";
import { LocaleContext, LoginContext, StateContext } from "./App";
import { loginFunc, postWithCsrf } from "./util";
import { TwoFactorAuth } from "./TwoFactorAuth";
import './TwoFactorAuthLogin.css'
import { Navigate } from "react-router-dom";
import { LoadState } from "./enums";
import { ClosePopup, LoadButton, NavigateSmart } from "./Common";

export function TwoFactorAuthLogin(props) {
    const state = useContext(StateContext);
    const login = useContext(LoginContext);
    const locale = useContext(LocaleContext);

    const [errorText, setErrorText] = useState("");
    const [loadState, setLoadState] = useState(LoadState.NONE);
    
    function handle2faCodeEntered(code) {
        try {
            loginFunc(login.username, login.password, code, state, login, props.management).then((json) => {
                setLoadState(LoadState.LOAD_SUCCESS);

                setErrorText(
                    <div className="text_success">
                        {locale.msgs.CODE_VALID}
                    </div>
                );

                login.setDisplayRememberDevice(true);

                login.setPassword("");
                props.onLogin(json);
            }).catch((error) => {
                setLoadState(LoadState.LOAD_ERROR);

                console.log("Login ERROR: " + error);
            
                setErrorText(
                    <div className="text_error">
                        {locale.msgs.INVALID_CODE}
                    </div>
                );
            });

            // Calling setLoadState() after loginFunc() as it could throw an exception
            setLoadState(LoadState.LOADING);
            setErrorText("");
        }
        catch(e) {
            console.log(e);
        }
    }

    function handle2faCodeChange() {
        setErrorText("");
    }


    // RENDER:

    const credsValid = login.username != "" && login.password != "";

    return(
        credsValid ? 
        <div id="two_factor_auth_login">
            <TwoFactorAuth on2faCodeEntered={handle2faCodeEntered} on2faCodeChange={handle2faCodeChange}
                    twoFactorType={login.twoFactorAuthType} nextSmsCountS={login.nextSmsCountS}
                    username={login.username} password={login.password} />

            { loadState === LoadState.LOADING ?
                <div className="loader margin_top_low"></div>
            :
                null
            }

            <div className="margin_top_low_low">{errorText}</div>
            
        </div>
        :
        <NavigateSmart to="/login"/>
    );
}
